<template>
    <div
        class="min-w-0 w-full h-50 rounded-lg overflow-hidden bg-white dark:bg-gray-800 mb-4 flex drop-shadow-sm p-5"
    >
        <div class="flex w-full" role="status" v-if="loading">
            <svg
                aria-hidden="true"
                class="mx-auto w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                />
            </svg>
            <span class="sr-only">Loading...</span>
        </div>
        <div class="w-full" v-else>
            <h3 class="text-lg leading-6 font-medium dark:text-white mt-1">
                Histórico
            </h3>
            <ol
                class="relative border-l border-gray-200 dark:border-gray-700 w-full mt-4"
            >
                <li
                    class="mb-10 ml-4"
                    v-for="(history, idx) in history_data"
                    :key="idx"
                >
                    <div class="flex row items justify-between w-full">
                        <div class="col col-span-7">
                            <div
                                class="bg-indigo-500 absolute w-3 h-3 rounded-full mt-1.5 -left-1.5 border border-white border-gray-500 dark:border-gray-900"
                            ></div>
                            <time
                                class="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500"
                                >{{ history.created_at }}</time
                            >
                            <h3
                                class="text-lg font-semibold text-gray-900 dark:text-white"
                            >
                                Motivo: {{ history.observation }}
                            </h3>
                            <div
                                class="text-base font-normal text-gray-500 dark:text-gray-400"
                            >
                                <p>
                                    Realizado por: {{ history.user.name }} ({{
                                        history.user.email
                                    }})
                                </p>
                            </div>
                        </div>
                        <div
                            class="flex col col-span-2 text-gray-400 cursor-pointer"
                            @click="openModalInfo(idx)"
                        >
                            <font-awesome-icon
                                icon="fa-solid fa-circle-info"
                                class="-mr-1 ml-2 h-5 w-5"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </li>
            </ol>
        </div>
        <financial-log-info-modal
            v-if="financial_info_modal"
            :history="history_selected"
            @closeModal="closeModal()"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../mixins/HelperMixin.vue";
import FinancialLogInfoModal from "../modals/FinancialLogInfoModal.vue";

export default {
    props: ["user"],
    mixins: [HelperMixin],
    components: {
        FinancialLogInfoModal,
    },
    data() {
        return {
            loading: false,
            history_data: {},
            history_selected: {},
            financial_info_modal: false,
        };
    },

    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.loading = true;
            axios
                .get("/api/user/" + this.user.id + "/settings/history")
                .then(({ data }) => {
                    this.history_data = data;

                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openModal() {
            this.financial_info_modal = true;
        },
        closeModal() {
            this.financial_info_modal = false;
        },
        openModalInfo(idx) {
            this.history_selected = this.history_data[idx];
            this.financial_info_modal = true;
        },
    },
};
</script>
